import React from 'react'
import axios from 'axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import UpsellModal from '~/Common-Objects/UpsellModal'
import DBConn from '~/Classes/siteVars.js'
import queryString from 'query-string'
import OfflineWeb from '~/assets/images/genericpagenotfound/noweb-desktop.png'
import { connect } from 'react-redux'
import { alterFullpage } from '~/data/actions/siteActions'

@connect((store) => {
    return { siteMaster: store.siteMaster }
})
export default class OAuthAuthorise extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataLoaded: false,
            dataIncorrect: false,
            oauthVersion: 1,
            appId: 0,
            redirect_uri: '',
            response_type: '',
            app_state: '',
            code_challenge: '',
            code_challenge_method: '',
            scope: '',
            mcpNotEnabled: false,
            mcpTierRequired: false,
            mcpRequiredTier: null,
            mcpUpgradeSucceeded: false,
            username: '',
            password: '',
            twoFaCode: '',
            requiresTwoFa: false,
            multipleAccounts: false,
            accounts: [],
            accountId: '',
            errors: {
                username: '',
                password: '',
                twoFaCode: ''
            },
            authorizationComplete: false,
            completionRedirectUrl: '',
            pendingRedirectUrl: '',
            checkingSession: false,
            sessionLoggedIn: false,
            sessionEmail: ''
        }

        this.loadApp = this.loadApp.bind(this)
        this.changeLogin = this.changeLogin.bind(this)
        this.checkLogin = this.checkLogin.bind(this)
        this.completeAuthorization = this.completeAuthorization.bind(this)
        this.returnToClient = this.returnToClient.bind(this)
        this.checkExistingSession = this.checkExistingSession.bind(this)
        this.confirmAuthorize = this.confirmAuthorize.bind(this)
        this.useDifferentAccount = this.useDifferentAccount.bind(this)
        this.clearMcpTierRequired = this.clearMcpTierRequired.bind(this)
        this.buildAuthConfig = this.buildAuthConfig.bind(this)
        this.buildAuthorizePayload = this.buildAuthorizePayload.bind(this)
        this.handleAuthorizeResponse = this.handleAuthorizeResponse.bind(this)
        this.accountLacksMcpTier = this.accountLacksMcpTier.bind(this)
        this.showMcpTierRequired = this.showMcpTierRequired.bind(this)
        this.persistBrowserSession = this.persistBrowserSession.bind(this)
        this.navigateToControlPanel = this.navigateToControlPanel.bind(this)
        this.showMcpUpsellModal = this.showMcpUpsellModal.bind(this)
        this.continueAfterMcpUpgrade = this.continueAfterMcpUpgrade.bind(this)
    }

    persistBrowserSession(payload) {
        if (!payload || !payload.token) {
            return
        }
        // Match the normal login path: persist the session token so a full CP
        // navigation can rehydrate and loadUserRecord can hydrate the rest.
        this.props.dispatch({
            type: 'LOGGEDIN_SUCCESS',
            payload: {
                token: payload.token,
                AccountUserId: payload.AccountUserId
            }
        })
        if (payload.AccountMasterId && payload.AccountMaster) {
            this.props.dispatch({
                type: 'LOGGEDIN_SUCCESS_ACCOUNTMASTER',
                payload: {
                    AccountMasterId: payload.AccountMasterId,
                    AccountMaster: payload.AccountMaster
                }
            })
        }
    }

    navigateToControlPanel(path) {
        // Full page load is required after authorize login: LOGGEDIN_SUCCESS sets
        // dataUpToDate=false, and the CP only renders once rehydrate sets it true.
        window.location.assign(path)
    }

    continueAfterMcpUpgrade() {
        const accountId = this.state.accountId
        const accounts = (this.state.accounts || []).map((account) => {
            if (accountId && parseInt(account.value, 10) === parseInt(accountId, 10)) {
                return { ...account, mcpTierAllowed: true }
            }
            return account
        })

        this.setState(
            {
                mcpTierRequired: false,
                mcpUpgradeSucceeded: false,
                accounts,
                sessionLoggedIn: true,
                checkingSession: true
            },
            () => this.confirmAuthorize()
        )
    }

    showMcpUpsellModal() {
        const requiredTierName =
            this.state.mcpRequiredTier && this.state.mcpRequiredTier.name ? this.state.mcpRequiredTier.name : null
        if (!requiredTierName) {
            return
        }

        const modal = (
            <UpsellModal
                feature='mcp'
                requiredTier={requiredTierName}
                inline={true}
                onUpgrade={() => {
                    this.setState({ mcpUpgradeSucceeded: true })
                }}
                onUpgradeComplete={() => {
                    if (this.state.mcpUpgradeSucceeded) {
                        this.continueAfterMcpUpgrade()
                    }
                }}
            />
        )
        this.props.dispatch(alterFullpage(modal))
    }

    accountLacksMcpTier(account) {
        return !!(account && account.mcpTierAllowed === false)
    }

    showMcpTierRequired(accountId) {
        this.setState({
            checkingSession: false,
            mcpTierRequired: true,
            accountId: accountId || this.state.accountId
        })
    }

    getStoredAuthToken() {
        try {
            const raw = localStorage.getItem('reduxPersist:user')
            if (!raw) {
                return null
            }
            const user = JSON.parse(raw)
            return user && user.token ? user.token : null
        } catch (error) {
            return null
        }
    }

    buildAuthConfig() {
        const token = this.getStoredAuthToken()
        const config = { withCredentials: true }
        if (token) {
            config.headers = { Authorization: 'Bearer ' + token }
        }
        return config
    }

    buildAuthorizePayload() {
        const payload = {
            appId: this.state.appId,
            client_id: this.state.appId,
            redirect_uri: this.state.redirect_uri,
            state: this.state.app_state,
            scope: this.state.scope,
            code_challenge: this.state.code_challenge,
            code_challenge_method: this.state.code_challenge_method,
            url: window.location.host.split('/')[0]
        }
        if (this.state.accountId) {
            payload.accountId = this.state.accountId
        }
        return payload
    }

    handleAuthorizeResponse(loginResponse) {
        this.persistBrowserSession(loginResponse.data)
        if (loginResponse.data.status === 'multiple_accounts') {
            this.setState({
                accounts: loginResponse.data.accounts,
                multipleAccounts: true,
                checkingSession: false,
                requiresTwoFa: false,
                mcpRequiredTier: loginResponse.data.mcpRequiredTier || this.state.mcpRequiredTier
            })
            return
        }
        if (loginResponse.data.status === '2fa_required') {
            this.setState({
                requiresTwoFa: true,
                checkingSession: false,
                errors: { username: '', password: '', twoFaCode: '' }
            })
            return
        }
        if (this.state.oauthVersion === 2 && loginResponse.data.redirectUrl) {
            // Generic clients need an explicit Connect consent step. Form login
            // (including after 2FA) does not set sessionLoggedIn, so pause here
            // instead of auto-completing like the branded flow.
            if (this.isGenericOAuthClient() && !this.state.sessionLoggedIn) {
                this.setState({
                    sessionLoggedIn: true,
                    requiresTwoFa: false,
                    multipleAccounts: false,
                    sessionEmail: this.state.username,
                    pendingRedirectUrl: loginResponse.data.redirectUrl,
                    checkingSession: false
                })
                return
            }
            this.completeAuthorization(loginResponse.data.redirectUrl)
        } else if (this.state.oauthVersion !== 2) {
            var finalUrl = this.state.redirect_uri + '?code=' + loginResponse.data.code
            if (this.state.app_state && this.state.app_state.length) {
                finalUrl += '&state=' + this.state.app_state
            }
            window.open(finalUrl, '_self')
        }
    }

    async checkExistingSession() {
        if (this.state.oauthVersion !== 2) {
            return
        }

        const authConfig = this.buildAuthConfig()
        if (!authConfig.headers) {
            return
        }

        this.setState({ checkingSession: true })
        const baseUrl = DBConn.getConnString()

        try {
            const sessionUrl = baseUrl + '/api/oauth2/authorize/session'
            const scopedSessionUrl = this.state.scope
                ? sessionUrl + '?scope=' + encodeURIComponent(this.state.scope)
                : sessionUrl
            const response = await axios.get(scopedSessionUrl, authConfig)
            if (response.data.mcpNotEnabled) {
                this.setState({
                    checkingSession: false,
                    mcpNotEnabled: true
                })
                return
            }
            if (!response.data.loggedIn || !response.data.accounts || !response.data.accounts.length) {
                this.setState({ checkingSession: false })
                return
            }

            if (response.data.accounts.length > 1) {
                this.setState({
                    checkingSession: false,
                    sessionLoggedIn: true,
                    sessionEmail: response.data.emailAddress,
                    accounts: response.data.accounts,
                    multipleAccounts: true,
                    mcpRequiredTier: response.data.mcpRequiredTier || null
                })
                return
            }

            const account = response.data.accounts[0]
            const accountId = account.value
            const mcpRequiredTier = response.data.mcpRequiredTier || null

            if (this.accountLacksMcpTier(account)) {
                this.setState({
                    checkingSession: false,
                    sessionLoggedIn: true,
                    sessionEmail: response.data.emailAddress,
                    accounts: response.data.accounts,
                    multipleAccounts: false,
                    accountId,
                    mcpTierRequired: true,
                    mcpRequiredTier
                })
                return
            }

            // Generic OAuth clients require explicit consent even with a single account.
            if (this.isGenericOAuthClient()) {
                this.setState({
                    checkingSession: false,
                    sessionLoggedIn: true,
                    multipleAccounts: false,
                    sessionEmail: response.data.emailAddress,
                    accounts: response.data.accounts,
                    accountId,
                    mcpRequiredTier
                })
                return
            }

            this.setState(
                {
                    checkingSession: true,
                    sessionLoggedIn: true,
                    sessionEmail: response.data.emailAddress,
                    accounts: response.data.accounts,
                    accountId,
                    multipleAccounts: false,
                    mcpRequiredTier
                },
                () => this.confirmAuthorize()
            )
        } catch (error) {
            this.setState({ checkingSession: false })
        }
    }

    async confirmAuthorize() {
        var errors = { username: '', password: '', twoFaCode: '' }
        var baseUrl = DBConn.getConnString()

        try {
            const loginResponse = await axios.post(
                baseUrl + '/api/oauth2/authorize/confirm',
                this.buildAuthorizePayload(),
                this.buildAuthConfig()
            )
            this.handleAuthorizeResponse(loginResponse)
        } catch (err) {
            if (this.state.sessionLoggedIn && err.response && err.response.status === 401) {
                this.useDifferentAccount()
                return
            }
            const apiError = err.response && err.response.data && err.response.data.error
            if (apiError === 'MCP is not enabled for this account') {
                this.setState({
                    checkingSession: false,
                    mcpNotEnabled: true,
                    errors
                })
                return
            }
            if (apiError === 'MCP is not available on this plan') {
                this.setState({
                    checkingSession: false,
                    mcpTierRequired: true,
                    mcpRequiredTier:
                        (err.response.data && err.response.data.mcpRequiredTier) || this.state.mcpRequiredTier,
                    errors
                })
                return
            }
            errors.username = 'There was an error authorizing the connection'
            errors.password = 'There was an error authorizing the connection'
            if (err.response && err.response.data && err.response.data.error) {
                errors.username = err.response.data.error
                errors.password = err.response.data.error
            }
            this.setState({ errors, checkingSession: false })
        }
    }

    useDifferentAccount() {
        this.setState({
            sessionLoggedIn: false,
            sessionEmail: '',
            multipleAccounts: false,
            accounts: [],
            accountId: '',
            checkingSession: false,
            requiresTwoFa: false,
            pendingRedirectUrl: '',
            username: '',
            password: '',
            twoFaCode: '',
            mcpNotEnabled: false,
            mcpTierRequired: false,
            mcpRequiredTier: null,
            mcpUpgradeSucceeded: false,
            errors: { username: '', password: '', twoFaCode: '' }
        })
    }

    clearMcpTierRequired() {
        if (this.state.accounts && this.state.accounts.length > 1) {
            this.setState({
                mcpTierRequired: false,
                accountId: '',
                multipleAccounts: true,
                checkingSession: false
            })
            return
        }
        this.useDifferentAccount()
    }

    isCustomSchemeRedirectUri(uri) {
        try {
            const { protocol } = new URL(uri)
            return protocol !== 'http:' && protocol !== 'https:'
        } catch (error) {
            return false
        }
    }

    isGenericOAuthClient() {
        if (this.state.oauthVersion !== 2 || !this.state.appData) {
            return false
        }

        const oauth2 = this.state.appData.options && this.state.appData.options.oauth2
        if (oauth2 && oauth2.genericAuthorizeUi === true) {
            return true
        }

        // MCP and similar clients use a shared public OAuth app with dynamic redirect URIs.
        return !!(oauth2 && oauth2.allowAnyRedirectUri === true)
    }

    getSiteLogo() {
        let ourSiteLogo = 'http://cdn1.ourmailsender.com/siteContent/transpondLogos/logomark_dark.png'
        if (this.props.siteMaster.siteId != 1) {
            ourSiteLogo = this.props.siteMaster.siteLogo
        }
        if (this.props.siteMaster.siteId == '4') {
            ourSiteLogo = 'http://cdn1.ourmailsender.com/siteContent/appLogos/myGoldMail.jpg'
        }
        return ourSiteLogo
    }

    getSiteName() {
        return this.props.siteMaster.siteName || 'Transpond'
    }

    localizeAppDescription(description) {
        if (!description) {
            return description
        }
        return description.replace(/transpond/gi, this.getSiteName())
    }

    completeAuthorization(redirectUrl) {
        this.setState(
            {
                authorizationComplete: true,
                completionRedirectUrl: redirectUrl,
                pendingRedirectUrl: '',
                checkingSession: false
            },
            () => {
                window.setTimeout(() => this.returnToClient(), 1500)
            }
        )
    }

    returnToClient() {
        if (!this.state.completionRedirectUrl) {
            return
        }
        window.location.assign(this.state.completionRedirectUrl)
    }

    componentDidMount() {
        const query = queryString.parse(location.search)
        const response_type = query.response_type
        const appid = query.client_id || query.appid
        const redirect_uri = query.redirect_uri
        const app_state = query.state
        const oauthVersion = query.v === '2' ? 2 : 1

        if (!appid || !redirect_uri) {
            this.setState({ dataIncorrect: true, dataLoaded: true })
            return
        }
        this.setState(
            {
                oauthVersion,
                appId: appid,
                redirect_uri: redirect_uri,
                response_type: response_type,
                app_state,
                scope: query.scope || '',
                code_challenge: query.code_challenge || '',
                code_challenge_method: query.code_challenge_method || ''
            },
            this.loadApp
        )
    }

    async loadApp() {
        var baseUrl = DBConn.getConnString()
        const appPath = this.state.oauthVersion === 2 ? '/api/oauth2/app/' : '/api/oauth/app/'
        try {
            let appResponse = await axios.get(baseUrl + appPath + this.state.appId)
            this.setState(
                { appData: appResponse.data.Application, dataIncorrect: false, dataLoaded: true },
                this.checkExistingSession
            )
        } catch (error) {
            console.error('Error loading app:', error)
            this.setState({ dataIncorrect: true, dataLoaded: true })
        }
    }

    changeLogin(event) {
        var theState = this.state
        theState[event.target.name] = event.target.value
        this.setState(theState)
    }

    async checkLogin() {
        var errors = { username: '', password: '', twoFaCode: '' }
        var errored = false

        if (this.state.sessionLoggedIn) {
            if (this.state.multipleAccounts && !this.state.accountId) {
                errors.username = 'Please select an account'
                this.setState({ errors })
                return
            }
            // Form login for generic clients already received the redirect URL;
            // Connect just confirms consent and finishes.
            if (this.state.pendingRedirectUrl) {
                return this.completeAuthorization(this.state.pendingRedirectUrl)
            }
            const selectedAccount =
                this.state.accounts &&
                this.state.accounts.find(
                    (account) => parseInt(account.value, 10) === parseInt(this.state.accountId, 10)
                )
            if (this.accountLacksMcpTier(selectedAccount)) {
                this.showMcpTierRequired(this.state.accountId)
                return
            }
            return this.confirmAuthorize()
        }

        if (!this.state.requiresTwoFa && !this.state.username) {
            errors.username = 'Invalid username'
            errored = true
        }
        if (!this.state.requiresTwoFa && !this.state.password) {
            errors.password = 'Invalid password'
            errored = true
        }
        if (this.state.requiresTwoFa && !this.state.twoFaCode) {
            errors.twoFaCode = 'Authentication code required'
            errored = true
        }
        if (errored) {
            this.setState({ errors: errors })
            return
        }

        var dataToPost = this.buildAuthorizePayload()
        dataToPost.username = this.state.username
        dataToPost.password = this.state.password
        dataToPost.twoFaCode = this.state.twoFaCode

        var baseUrl = DBConn.getConnString()
        const loginPath =
            this.state.oauthVersion === 2
                ? '/api/oauth2/authorize/login'
                : '/api/oauth/app/' + this.state.appId + '/login'
        try {
            let loginResponse = await axios.post(baseUrl + loginPath, dataToPost, this.buildAuthConfig())
            this.handleAuthorizeResponse(loginResponse)
        } catch (err) {
            const apiError = err.response && err.response.data && err.response.data.error
            if (apiError === 'MCP is not enabled for this account') {
                this.persistBrowserSession(err.response.data)
                this.setState({
                    mcpNotEnabled: true,
                    errors
                })
                return
            }
            if (apiError === 'MCP is not available on this plan') {
                this.persistBrowserSession(err.response.data)
                this.setState({
                    mcpTierRequired: true,
                    mcpRequiredTier:
                        (err.response.data && err.response.data.mcpRequiredTier) || this.state.mcpRequiredTier,
                    errors
                })
                return
            }
            errors.username = 'There was an error logging in'
            errors.password = 'There was an error logging in'
            if (err.response && err.response.data && err.response.data.error) {
                errors.username = err.response.data.error
                errors.password = err.response.data.error
            }
            this.setState({ errors })
        }
    }

    renderMcpNotEnabled() {
        const siteName = this.getSiteName()
        const primaryColor = this.props.siteMaster.colours['$primary']

        return (
            <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Paper className='with_header' style={{ width: '100%', minWidth: '300px', maxWidth: '520px' }}>
                    <div className='paper_header' style={{ backgroundColor: primaryColor, color: 'white' }}>
                        <div className='quickFlex' style={{ alignItems: 'center' }}>
                            <Icons icon='alert' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                            <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                MCP not available
                            </div>
                        </div>
                    </div>
                    <div className='paper_content'>
                        <div className='mar-b10 text-heavy' style={{ fontSize: 18 }}>
                            This account cannot connect to MCP
                        </div>
                        <div className='mar-b25'>
                            {this.state.multipleAccounts
                                ? 'None of your accounts have MCP enabled. Choose a different account or enable MCP in Labs for the account you want to use.'
                                : `MCP is not enabled for the selected ${siteName} account. Enable the Transpond MCP beta in Labs, then try connecting again.`}
                        </div>
                        <Button
                            className='button-primary'
                            text='Enable MCP'
                            onClick={() => {
                                this.navigateToControlPanel('/cp/labs')
                            }}
                        />
                        <Button
                            className='mar-l5'
                            text='Log in with a different account'
                            onClick={this.useDifferentAccount}
                        />
                    </div>
                </Paper>
            </div>
        )
    }

    renderMcpTierRequired() {
        const siteName = this.getSiteName()
        const primaryColor = this.props.siteMaster.colours['$primary']
        const requiredTierName =
            this.state.mcpRequiredTier && this.state.mcpRequiredTier.name ? this.state.mcpRequiredTier.name : null

        return (
            <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Paper className='with_header' style={{ width: '100%', minWidth: '300px', maxWidth: '520px' }}>
                    <div className='paper_header' style={{ backgroundColor: primaryColor, color: 'white' }}>
                        <div className='quickFlex' style={{ alignItems: 'center' }}>
                            <Icons icon='alert' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                            <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                Upgrade required
                            </div>
                        </div>
                    </div>
                    <div className='paper_content'>
                        <div className='mar-b10 text-heavy' style={{ fontSize: 18 }}>
                            {requiredTierName
                                ? `Upgrade to ${requiredTierName} to use MCP`
                                : 'MCP is not on your current plan'}
                        </div>
                        <div className='mar-b25'>
                            {requiredTierName
                                ? `The selected ${siteName} account needs the ${requiredTierName} plan (or higher) to connect to MCP. Upgrade your subscription, or choose a different account.`
                                : `The selected ${siteName} account is not on a plan that includes MCP. Upgrade your subscription to connect, or choose a different account.`}
                        </div>
                        <Button
                            className='button-primary'
                            text={requiredTierName ? `Upgrade to ${requiredTierName}` : 'Upgrade'}
                            onClick={this.showMcpUpsellModal}
                            disabled={!requiredTierName}
                        />
                        <Button
                            className='mar-l5'
                            text={
                                this.state.accounts && this.state.accounts.length > 1
                                    ? 'Choose a different account'
                                    : 'Log in with a different account'
                            }
                            onClick={this.clearMcpTierRequired}
                        />
                    </div>
                </Paper>
            </div>
        )
    }

    renderSuccess() {
        const generic = this.isGenericOAuthClient()
        const appName =
            this.state.appData && this.state.appData.appName ? this.state.appData.appName : 'the application'
        const customScheme = this.isCustomSchemeRedirectUri(this.state.completionRedirectUrl)
        const primaryColor = this.props.siteMaster.colours['$primary']

        return (
            <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Paper className='with_header' style={{ width: '100%', minWidth: '300px', maxWidth: '600px' }}>
                    <div className='paper_header' style={{ backgroundColor: primaryColor, color: 'white' }}>
                        <div className='quickFlex' style={{ alignItems: 'center' }}>
                            <Icons
                                icon='tickCircle'
                                color={'#FFFFFF'}
                                style={{ width: '20px', height: '20px' }}
                            />
                            <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                Connected
                            </div>
                        </div>
                    </div>
                    <div className='paper_content'>
                        <div className='mar-b10 text-heavy' style={{ fontSize: 18 }}>
                            You're all set
                        </div>
                        <div className='mar-b25'>
                            {generic
                                ? 'Your account is now connected.'
                                : `Your account is now connected to ${appName}.`}
                            {/* Generic (MCP) clients still redirect via completeAuthorization; closing the tab early aborts the connection. */}
                            {customScheme
                                ? ' You can close this window and return to your application.'
                                : ' Redirecting you back now...'}
                        </div>
                        {/* No button for generic (MCP) clients: a second navigation to the callback breaks the flow, so leave it to the automatic redirect. */}
                        {customScheme && !generic && (
                            <Button
                                className='button-primary'
                                text={'Return to ' + appName}
                                onClick={this.returnToClient}
                            />
                        )}
                    </div>
                </Paper>
            </div>
        )
    }

    renderAuthorizeActions() {
        return (
            <>
                {this.state.sessionLoggedIn && this.state.sessionEmail && (
                    <>
                        <div className='mar-b25'>
                            Signed in as <span className='text-heavy'>{this.state.sessionEmail}</span>
                        </div>
                    </>
                )}

                {this.state.multipleAccounts && (
                    <div className='text-left mar-b25'>
                        <Select
                            label='Select Account to connect'
                            name='accountId'
                            value={this.state.accountId}
                            onChange={(event) => this.setState({ accountId: event.target.value })}
                            data={this.state.accounts.map((bind) => ({ label: bind.label, value: bind.value }))}
                        />
                    </div>
                )}
                {(this.state.sessionLoggedIn || this.state.multipleAccounts) && (
                    <>
                        <Button
                            className='button-primary'
                            text='Connect'
                            onClick={() => this.checkLogin()}
                            disabled={this.state.multipleAccounts && !this.state.accountId}
                        />

                        {this.state.sessionLoggedIn && (
                            <Button
                                className='mar-l10'
                                text='Use a different account'
                                onClick={this.useDifferentAccount}
                            />
                        )}
                    </>
                )}
                {!this.state.sessionLoggedIn && !this.state.multipleAccounts && !this.state.requiresTwoFa && (
                    <>
                        <div className='text-left mar-b25'>
                            <TextInput
                                label='Username'
                                name='username'
                                value={this.state.username}
                                error={this.state.errors.username}
                                onChange={this.changeLogin}
                                type='email'
                                outerClassName='mar-b10'
                            />
                            <TextInput
                                label='Password'
                                name='password'
                                value={this.state.password}
                                error={this.state.errors.password}
                                onChange={this.changeLogin}
                                type='password'
                            />
                        </div>
                        <Button className='button-primary' text='Login and Connect' onClick={this.checkLogin} />
                    </>
                )}
                {!this.state.sessionLoggedIn && !this.state.multipleAccounts && this.state.requiresTwoFa && (
                    <>
                        <div className='text-left mar-b25'>
                            <TextInput
                                label='Authentication Code'
                                name='twoFaCode'
                                value={this.state.twoFaCode}
                                error={this.state.errors.twoFaCode}
                                onChange={this.changeLogin}
                                type='text'
                            />
                        </div>
                        <Button className='button-primary' text='Verify and Connect' onClick={this.checkLogin} />
                    </>
                )}
            </>
        )
    }

    renderGenericAuthorize() {
        const siteName = this.getSiteName()
        const primaryColor = this.props.siteMaster.colours['$primary']
        const appDescription = this.localizeAppDescription(this.state.appData.appDescription)

        return (
            <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Paper className='with_header' style={{ width: '100%', minWidth: '300px', maxWidth: '520px' }}>
                    <div className='paper_header' style={{ backgroundColor: primaryColor, color: 'white' }}>
                        <div className='quickFlex' style={{ alignItems: 'center' }}>
                            <Icons icon='link' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                            <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                Authorize access
                            </div>
                        </div>
                    </div>
                    <div className='paper_content'>
                        <div className='quickFlex' style={{ justifyContent: 'center', marginBottom: 24 }}>
                            <img
                                src={this.getSiteLogo()}
                                className='rounded'
                                style={{ width: '56px', height: '56px', objectFit: 'contain' }}
                                alt=''
                            />
                        </div>

                        <div className='mar-b10 text-heavy text-center' style={{ fontSize: 20 }}>
                            Sign in to {siteName}
                        </div>
                        <div className='mar-b25 text-center'>
                            An application is requesting access to your {siteName} account.
                            {appDescription
                                ? ' ' + appDescription
                                : ' Sign in below to review and approve the connection.'}
                        </div>

                        <div
                            className='mar-b25'
                            style={{
                                backgroundColor: 'var(--neutral-50, #f7f7f8)',
                                borderRadius: 8,
                                padding: '16px 18px'
                            }}
                        >
                            <div className='text-heavy mar-b10' style={{ fontSize: 14 }}>
                                This will allow the application to:
                            </div>
                            <div className='quickFlex mar-b8' style={{ alignItems: 'flex-start' }}>
                                <Icons
                                    icon='tick'
                                    className='mar-r8'
                                    style={{ width: 16, height: 16, marginTop: 2, flexShrink: 0 }}
                                />
                                <span>Access your {siteName} account via the API</span>
                            </div>
                            <div className='quickFlex' style={{ alignItems: 'flex-start' }}>
                                <Icons
                                    icon='tick'
                                    className='mar-r8'
                                    style={{ width: 16, height: 16, marginTop: 2, flexShrink: 0 }}
                                />
                                <span>Perform actions on your behalf according to the permissions you grant</span>
                            </div>
                        </div>

                        {this.renderAuthorizeActions()}
                    </div>
                </Paper>
            </div>
        )
    }

    renderBrandedAuthorize() {
        const ourAppDescription = this.localizeAppDescription(this.state.appData.appDescription)

        return (
            <div className='container-fluid'>
                <Row className='center-xs middle-xs around-xs height-100-vh'>
                    <Column>
                        <Paper className='max-width-500'>
                            <h4 className='mar-b25'>
                                Connect your account to{' '}
                                <span className='text-heavy text-primary'>{this.state.appData.appName}</span>
                            </h4>

                            <Row className='middle-xs mar-b30'>
                                <Column xs={4} margin={0} className='end-xs'>
                                    <img
                                        src={this.getSiteLogo()}
                                        className='rounded'
                                        style={{ width: '50px' }}
                                        alt=''
                                    />
                                </Column>
                                <Column xs={4} margin={0}>
                                    <span className='icon-tab text-lg2 text-grey'></span>
                                </Column>
                                <Column xs={4} margin={0} className='start-xs'>
                                    <img
                                        src={this.state.appData.appLogoUri}
                                        className='rounded'
                                        style={{ width: '50px' }}
                                        alt=''
                                    />
                                </Column>
                            </Row>

                            <div className='mar-b25'>{ourAppDescription}</div>
                            {this.renderAuthorizeActions()}
                        </Paper>
                    </Column>
                </Row>
            </div>
        )
    }

    render() {
        if (!this.state.dataLoaded || this.state.checkingSession)
            return (
                <div className='container-fluid'>
                    <Row className='center-xs middle-xs around-xs height-100-vh'>
                        <Column>
                            <Paper className='max-width-500'>
                                <LoadingIcons iconType='2' className='mar-b15' />
                                <h4 className='text-center'>Checking your login...</h4>
                            </Paper>
                        </Column>
                    </Row>
                </div>
            )
        if (this.state.authorizationComplete) return this.renderSuccess()
        if (this.state.mcpNotEnabled) return this.renderMcpNotEnabled()
        if (this.state.mcpTierRequired) return this.renderMcpTierRequired()
        if (this.state.dataIncorrect)
            return (
                <div className='quickFlex' style={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                    <Paper
                        className='with_header'
                        style={{ width: '100%', minWidth: '300px', maxWidth: '600px' }}
                    >
                        <div
                            className='paper_header'
                            style={{ backgroundColor: this.props.siteMaster.colours['$primary'], color: 'white' }}
                        >
                            <div className='quickFlex' style={{ alignItems: 'center' }}>
                                <Icons icon='alert' color={'#FFFFFF'} style={{ width: '20px', height: '20px' }} />
                                <div className='mar-l10 text-heavy' style={{ fontSize: 16 }}>
                                    Somethings Wrong
                                </div>
                            </div>
                        </div>
                        <div className='paper_content'>
                            <div className='mar-b10'>It looks like something has not worked as expected.</div>
                            <div className='mar-b25'>Please try again.</div>
                            <Button
                                className='button-primary'
                                text='Continue'
                                onClick={() => {
                                    this.props.history.push('/')
                                }}
                            />
                        </div>
                    </Paper>
                </div>
            )

        if (this.isGenericOAuthClient()) {
            return this.renderGenericAuthorize()
        }

        return this.renderBrandedAuthorize()
    }
}
